import * as Immutable from 'immutable';

export interface IPreviewStore {
	id: number
	slug: string
	theorder: number
	url: string
	deleted: boolean
}

const defaultPreviewStore = Immutable.Record<IPreviewStore>({
	id: 0,
	slug: "",
	theorder: 0,
	url: "",
	deleted: false,
});

export default class PreviewStore extends defaultPreviewStore implements IPreviewStore {}